import { render, staticRenderFns } from "./CaptchaComponent.vue?vue&type=template&id=50df3b5a&lang=pug"
import script from "./CaptchaComponent.vue?vue&type=script&lang=js"
export * from "./CaptchaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50df3b5a')) {
      api.createRecord('50df3b5a', component.options)
    } else {
      api.reload('50df3b5a', component.options)
    }
    module.hot.accept("./CaptchaComponent.vue?vue&type=template&id=50df3b5a&lang=pug", function () {
      api.rerender('50df3b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CaptchaComponent.vue"
export default component.exports